(() => {
  'use strict';
  const KEY = 'techub-theme-mode';
  const MODES = ['auto', 'light', 'dark'];
  const root = document.documentElement;
  const button = document.querySelector('.techub-theme-toggle');
  const media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
  const isArabic = (root.lang || '').toLowerCase().startsWith('ar');
  const labels = {
    auto: isArabic ? (button?.dataset.labelArAuto || 'تلقائي') : (button?.dataset.labelEnAuto || 'Auto'),
    light: isArabic ? (button?.dataset.labelArLight || 'فاتح') : (button?.dataset.labelEnLight || 'Light'),
    dark: isArabic ? (button?.dataset.labelArDark || 'داكن') : (button?.dataset.labelEnDark || 'Dark')
  };
  let mode = 'auto';
  try {
    const stored = localStorage.getItem(KEY);
    if (stored && MODES.includes(stored)) mode = stored;
  } catch (_) {}

  function apply(nextMode) {
    mode = MODES.includes(nextMode) ? nextMode : 'auto';
    const systemDark = Boolean(media && media.matches);
    const effective = mode === 'dark' || (mode === 'auto' && systemDark) ? 'dark' : 'light';
    root.setAttribute('data-techub-preference', mode);
    root.setAttribute('data-techub-mode', effective);
    // Keep browser chrome / iOS standalone status area aligned with the active palette.
    document.querySelectorAll('meta[name="theme-color"]').forEach((meta) => {
      meta.setAttribute('content', effective === 'dark' ? '#17171d' : '#5C559E');
    });
    if (!button) return;
    const icon = button.querySelector('.techub-theme-toggle__icon');
    const label = button.querySelector('.techub-theme-toggle__label');
    const modeLabel = labels[mode];
    const prefix = isArabic ? (button.dataset.ariaAr || 'وضع المظهر') : (button.dataset.ariaEn || 'Theme mode');
    button.setAttribute('aria-label', `${prefix}: ${modeLabel}`);
    button.setAttribute('title', `${prefix}: ${modeLabel}`);
    button.setAttribute('aria-pressed', String(mode === 'dark'));
    button.dataset.mode = mode;
    if (label) label.textContent = modeLabel;
    if (icon) icon.textContent = mode === 'dark' ? '☾' : mode === 'light' ? '☀' : '◐';
  }

  apply(mode);
  button?.addEventListener('click', () => {
    const nextMode = MODES[(MODES.indexOf(mode) + 1) % MODES.length];
    try { localStorage.setItem(KEY, nextMode); } catch (_) {}
    apply(nextMode);
  });
  const onSystemChange = () => { if (mode === 'auto') apply('auto'); };
  if (media?.addEventListener) media.addEventListener('change', onSystemChange);
  else if (media?.addListener) media.addListener(onSystemChange);
})();
